import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';

export function NotFoundPage() {
  return (
    <div className="grid place-items-center py-24 text-center">
      <div>
        <p className="font-display text-6xl font-bold tracking-tight">404</p>
        <p className="mt-2 text-sm text-muted-foreground">This page doesn't exist.</p>
        <Button asChild className="mt-6" variant="outline">
          <Link to="/">Back to Overview</Link>
        </Button>
      </div>
    </div>
  );
}
